// extracted by mini-css-extract-plugin
export default {"cancelLink":"_R-z"};